module.exports = __webpack_public_path__ + "static/media/level-up-bg-layer.c29d31d3.png";